import { CopyId } from "@/components/copy-id";
import { Badge } from "@/components/ui/badge";
import { TableCell, TableRow } from "@/components/ui/table";
import { type ProfileCard } from "@/providers/cards.provider";
import { IconPhoto } from "@tabler/icons-react";

export function ActiveBadge({ isActive }: { isActive: boolean }) {
  return isActive ? (
    <Badge variant="outline" className="border-green-500 text-green-600">
      Active
    </Badge>
  ) : (
    <Badge variant="secondary">Inactive</Badge>
  );
}

export function CardRow({
  card,
  onClick,
}: {
  card: ProfileCard;
  onClick: () => void;
}) {
  const imgSrc = card.img_url ?? null;
  const createdAt = new Date(card.created_at).toLocaleDateString();

  return (
    <TableRow className="cursor-pointer" onClick={onClick}>
      <TableCell>
        <div className="flex items-center gap-2">
          <CopyId id={card.profile_card_id} />
        </div>
      </TableCell>
      <TableCell>
        <div className="flex items-center gap-3">
          {imgSrc ? (
            <img
              src={imgSrc}
              alt={card.name}
              className="size-8 rounded object-cover border"
            />
          ) : (
            <div className="size-8 rounded border bg-muted flex items-center justify-center">
              <IconPhoto className="size-4 text-muted-foreground" />
            </div>
          )}
          <span className="font-medium">{card.name}</span>
        </div>
      </TableCell>
      <TableCell className="text-muted-foreground max-w-xs truncate">
        {card.description || "—"}
      </TableCell>
      <TableCell>
        <div className="flex items-center gap-1.5">
          <span
            className="size-4 rounded-full border shrink-0"
            style={{ backgroundColor: card.primary_color }}
            title={`Primary: ${card.primary_color}`}
          />
          <span
            className="size-4 rounded-full border shrink-0"
            style={{ backgroundColor: card.secondary_color }}
            title={`Secondary: ${card.secondary_color}`}
          />
        </div>
      </TableCell>
      <TableCell>
        <ActiveBadge isActive={card.is_active} />
      </TableCell>
      <TableCell className="text-muted-foreground text-xs">{createdAt}</TableCell>
    </TableRow>
  );
}
